import type React from 'react';

import { XingletLoader } from '@xing-com/crate-xinglet';

import { useSearchContext } from '../../context';

export const SearchErrorDisplay: React.FC = () => {
  const { error, listLength } = useSearchContext();

  if (!error) return null;
  if (listLength > 0) return null;

  return (
    <XingletLoader
      name="@xing-com/crate-communication-error-pages"
      errorType="Generic"
    />
  );
};
